import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavigationControl } from 'react-map-gl';

class NavController extends PureComponent {
  render() {
    const { handleViewportChange, showCompass } = this.props;
    return (
      <div style={{ position: 'absolute', right: 2, bottom: 2 }}>
        <NavigationControl onViewportChange={handleViewportChange} showCompass={showCompass} />
      </div>
    );
  }
}

NavController.propTypes = {
  handleViewportChange: PropTypes.func.isRequired,
  showCompass: PropTypes.bool,
};

NavController.defaultProps = {
  showCompass: false,
};

export default NavController;
